import {FC} from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { WebUser } from '../../modules/core/users'

type Props = {
  user: WebUser
  isPrimary?: boolean
}

const UserInfoCell: FC<Props> = ({user, isPrimary = false}) => (
  <div className='d-flex align-items-center min-w-150px'>    
    <div className='symbol symbol-square symbol-40px overflow-hidden me-3'>
      <div className='symbol-label'>
        <KTSVG
          path='/media/icons/duotune/communication/com013.svg'
          className={'svg-icon-3x ' + (isPrimary ? 'svg-icon-primary' : 'svg-icon-gray-500')}                    
        />
      </div>                    
    </div>
    <div className='d-flex flex-column'>
      <div className='text-gray-800 text-hover-primary fs-7'>
        {user.name}
      </div>
      <span className="fs-8">{user.email}</span>
    </div>
  </div>
)

export {UserInfoCell}
